import { getDropdownNetworks, getColor } from '@/libs/utils/icons'

export const formatProposalForCheckout = (proposal_detail) => {
  return {
    user: {
      first_name: proposal_detail.first_name,
      last_name: proposal_detail.last_name,
      avatar: proposal_detail.avatar,
    },
    // agency disabled for the moment
    // agency: {},
  }
}

export const getOnlySomeDataFromDetails = (details, keys) => { 
  return details ? keys.reduce((acc, key) => ({ ...acc, [key]: details[key] }), {}) : null;
}

export const formatNetworkDonutData = (networks) => {
  const option_networks = getDropdownNetworks()
  const data = { labels: [], series: [], colors: [], total: 0 }
  
  Object.entries(networks).forEach(([key, value]) => {
    const network_name = option_networks.find(net => net.value === key)
    
    data.labels.push(network_name.network)
    data.series.push(value);
    data.colors.push(getColor(key, true));
    data.total += value;
  })
  return data;
}

export const getUsernameFormattingForDonut = (network) => {
  const { username, network: networkName } = network

  const isUrl = /^https?:\/\//i.test(username) || /^www\./i.test(username)

  if (!isUrl) return username

  if (networkName === 'blog') {
    return username.replace(/^https?:\/\//i, '').replace(/\/$/, '')
  }

  try {
    const url = new URL(username.startsWith('www.') ? `https://${username}` : username)
    const pathParts = url.pathname.replace(/\/$/, '').split('/').filter(Boolean)
    const lastSegment = pathParts[pathParts.length - 1] || url.hostname
    return lastSegment.replace(/^@/, '')
  } catch {
    return username
  }
}